<template>
  <v-app>
    <v-main class="guest-confirm">
      <v-container class="py-8" style="max-width: 520px;">
        <div class="text-center mb-6">
          <div class="guest-brand mb-2">Visitor invite</div>
          <h1 class="text-h5 mb-1">Confirm your visit</h1>
          <p class="grey--text text--darken-1 mb-0">Review the details below and confirm so reception can expect you.</p>
        </div>

        <v-alert v-if="error" type="error" dense text class="mb-4">{{ error }}</v-alert>
        <v-alert v-if="confirmed" type="success" dense text class="mb-4">Thanks — your visit is confirmed.</v-alert>

        <v-skeleton-loader v-if="loading" type="article"></v-skeleton-loader>

        <v-card v-else-if="visit" outlined class="pa-5">
          <div class="vms-form-section mb-0">
            <span class="vms-form-section__label">Visit summary</span>
            <div class="mb-3">
              <div class="text-caption grey--text">Host</div>
              <div class="font-weight-medium">{{ visit.host_name || '—' }}</div>
            </div>
            <div class="mb-3">
              <div class="text-caption grey--text">Location</div>
              <div class="font-weight-medium">{{ visit.facility || '—' }}</div>
            </div>
            <div class="mb-2">
              <div class="text-caption grey--text">When</div>
              <div class="font-weight-medium">{{ visit.event_date }} · {{ visit.start_at }} – {{ visit.end_at }}</div>
            </div>
          </div>

          <div class="vms-form-section mt-4">
            <span class="vms-form-section__label">Your details</span>
            <v-form class="vms-form" ref="form" v-model="valid">
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    dense
                    outlined
                    hide-details="auto"
                    label="Full name"
                    v-model="form.guest_name"
                    :rules="[(v) => !!v || 'Required']"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field
                    dense
                    outlined
                    hide-details="auto"
                    label="Phone"
                    v-model="form.phone"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field
                    dense
                    outlined
                    hide-details="auto"
                    label="National ID"
                    v-model="form.id_number"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </div>

          <div class="text-center my-5" v-if="qrSrc">
            <img :src="qrSrc" alt="Invite QR" width="160" height="160" />
            <div class="text-caption grey--text mt-2">Show this QR at reception</div>
          </div>

          <v-btn
            block
            color="primary"
            class="text-capitalize mt-1"
            height="44"
            :loading="submitting"
            :disabled="confirmed"
            @click="confirm"
          >
            {{ confirmed ? 'Confirmed' : 'Confirm visit' }}
          </v-btn>
        </v-card>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import VmsService from '../../services/vms.service';

export default {
  name: 'GuestConfirm',
  data() {
    return {
      loading: true,
      submitting: false,
      valid: false,
      error: null,
      confirmed: false,
      visit: null,
      form: {
        guest_name: '',
        phone: '',
        id_number: '',
      },
    };
  },
  computed: {
    token() {
      return this.$route.params.token;
    },
    qrSrc() {
      if (!this.token) return null;
      const api = process.env.VUE_APP_API_URL;
      return `${api}public/visits/${this.token}/qr`;
    },
  },
  created() {
    this.load();
  },
  methods: {
    async load() {
      this.loading = true;
      this.error = null;
      try {
        const res = await VmsService.publicShow(this.token);
        this.visit = res?.data?.data ?? res?.data ?? null;
        if (!this.visit) {
          this.error = 'Invite not found';
          return;
        }
        this.form.guest_name = this.visit.guest_name || '';
        this.form.phone = this.visit.guest_phone || '';
        this.form.id_number = this.visit.id_number || '';
        this.confirmed = !!this.visit.guest_confirmed_at;
      } catch (e) {
        this.error = e.response?.data?.message || 'Invite not found or expired';
      } finally {
        this.loading = false;
      }
    },
    async confirm() {
      if (this.$refs.form && !this.$refs.form.validate()) return;
      this.submitting = true;
      this.error = null;
      try {
        const res = await VmsService.publicConfirm(this.token, this.form);
        this.visit = res?.data?.data ?? this.visit;
        this.confirmed = true;
      } catch (e) {
        this.error = e.response?.data?.message || 'Could not confirm visit';
      } finally {
        this.submitting = false;
      }
    },
  },
};
</script>

<style scoped>
.guest-confirm {
  background: linear-gradient(160deg, #f5f7fb 0%, #e8eef6 45%, #f8fafc 100%);
  min-height: 100vh;
}
.guest-brand {
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  font-size: 12px;
  color: #0d47a1;
}
</style>
